// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7759) return "static/chunks/7759-f549d28fee5916e4.js";
	if (chunkId === 4295) return "static/chunks/4295-57fa53c88813c349.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8797 ? "af011179" : chunkId) + "." + {"152":"33081cc9ce130a3d","5369":"4a471ed05d641813","5488":"828e007a574dfd15","7788":"a3184d7523c7cde0","8797":"2a23c8d366752564"}[chunkId] + ".js";
};